import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl + '/api/perfiles';

const getInfPoblacion = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/getInfopoblacional`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const Infopiramide = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/Infopiramide`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const poblaciondesagregada = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/poblaciondesagregada`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const getcomponenteAmbiental = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/getcomponenteAmbiental`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const eventosdesastres = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/eventosdesastres`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const componenteagropecuario = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/componenteagropecuario`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const Infocomponenteeconomico = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/Infocomponenteeconomico`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const poblacionetnias = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/poblacionetnias`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const red_vial = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/red_vial`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const mineriacausas = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/mineriacausas`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const fauna = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/fauna`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const resultados_operativos = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/resultados_operativos`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const servicios_publicos = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/servicios_publicos`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const categorizacion_vial = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/categorizacion_vial`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};

const organismoscomunales = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/organismoscomunales`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const poblacionalgenero = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/poblacionalgenero`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const informacionsisben = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/informacionsisben`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const areaEcosistemas = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/areaEcosistemas`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const Infomineria = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/Infomineria`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const red_terciaria = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/red_terciaria`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const actividadeconomica = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/actividadeconomica`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const usoSuelo = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/usoSuelo`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const vocacionagricola = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/vocacionagricola`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const getInfocultivostranper = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/getInfocultivostranper`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const seguridad_ciudadana = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/seguridad_ciudadana`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const poblacionVictima = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/poblacionVictima`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const estadisticahurto = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/estadisticahurto`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const violenciaGenero = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/violenciaGenero`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const seguramientosalud = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/seguramientosalud`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const tasamortalidad = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/tasamortalidad`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const mortalidadinfantil = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/mortalidadinfantil`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const coberturavacunacion = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/coberturavacunacion`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const coberturaeducativa = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/coberturaeducativa`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const tasa_desercion = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/tasa_desercion`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const tasarepitencia = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/tasarepitencia`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const Infopruebasmatematicas = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/Infopruebasmatematicas`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const Infopruebaslectura = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/pruebasLecturaController`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const institucioneseducativas = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/institucioneseducativas`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const propiacion_municipal = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/propiacion_municipal`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const asignacionPresupuestal = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/asignacionPresupuestal`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const sistemaGeneralParticipaciones = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/sistemaGeneralParticipaciones`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const indiceDesempeno = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/indiceDesempeno`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const organizacionesagropecuarias = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/organizacionesagropecuarias`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const resguardosindigenas = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/resguardosindigenas`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
const Infoconsejoscomunitarios = async (municipioId) => {
    try {
        const response = await axios.get(`${baseUrl}/Infoconsejoscomunitarios`, {
            params: { municipioId } // Enviando municipioId como parámetro
        });
        return {
            status: response.status,
            data: response.data,
        };
    } catch (error) {
        console.error('Error obteniendo las áreas', error);
        throw error;
    }
};
export {
    getInfPoblacion, Infopiramide,eventosdesastres,actividadeconomica,
    estadisticahurto,coberturaeducativa,institucioneseducativas,
    poblaciondesagregada, getcomponenteAmbiental,vocacionagricola,
    getInfocultivostranper,tasa_desercion,propiacion_municipal,
    componenteagropecuario, Infocomponenteeconomico,organismoscomunales,
    usoSuelo,seguramientosalud,Infopruebaslectura,indiceDesempeno,
    poblacionetnias, red_vial, mineriacausas, fauna,red_terciaria,seguridad_ciudadana,
    mortalidadinfantil,asignacionPresupuestal,organizacionesagropecuarias,
    resultados_operativos, servicios_publicos, categorizacion_vial, poblacionVictima,
    coberturavacunacion,Infopruebasmatematicas,resguardosindigenas,
    poblacionalgenero, informacionsisben, areaEcosistemas,Infomineria,violenciaGenero,
    tasamortalidad,tasarepitencia,sistemaGeneralParticipaciones,Infoconsejoscomunitarios
};